import { IFormWidgetStyleData } from "src/typings/form-widget-style-data";
import { FormFieldStyleRenderer } from "./form-field-style-renderer";
import { FormLabelStyleRenderer } from "./form-label-renderer";
import { FormSubmitStyleRenderer } from "./form-submit-renderer";
import { ICssProperty } from "src/models/css-property";

export class FormStyleRenderer {

    private readonly fieldStyleRenderer: FormFieldStyleRenderer;
    private readonly labelStyleRenderer: FormLabelStyleRenderer;
    private readonly submitStyleRenderer: FormSubmitStyleRenderer;

    constructor() {
        this.fieldStyleRenderer = new FormFieldStyleRenderer();
        this.labelStyleRenderer = new FormLabelStyleRenderer();
        this.submitStyleRenderer = new FormSubmitStyleRenderer();
    }

    public getStyles(style: IFormWidgetStyleData): ICssProperty[] {
        const formFiledStyle = this.fieldStyleRenderer.getStyles(style.fields);
        const formLabelStyle = this.labelStyleRenderer.getStyles(style.labels);
        const formSubmitStyle = this.submitStyleRenderer.getStyles(style.submit);

        return [...formFiledStyle, ...formLabelStyle, ...formSubmitStyle];
    }

}
